module.exports = __webpack_public_path__ + "b37e00c4f2ed1d0047c7d7b5aaaef275.pdf";